<template>
<div class="cfd-list">
    <InstrumentsListItem
        v-for="instrument in instrumentsToShow"
        :instrument="instrument"
        :name-key="firstColumnName"
        :key="instrument.Id"/>
</div>
</template>

<script>
import InstrumentsListItem from './InstrumentsListItem.vue';

export default {
    name: 'InstrumentsList',

    components: {
        InstrumentsListItem
    },

    computed: {
        columnsToShow () {
            return this.$store.state.columnsToShow;
        },

        firstColumnName () {
            return this.columnsToShow[0].MatchingFieldName;
        },

        instrumentsToShow () {
            return this.$store.state.instrumentsToShow;
        }
    }
};
</script>

<style scoped>
.cfd-list {
    padding-top: 8px;
    padding-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/InstrumentsList.vue